// Japanese translations (日本語)
import { TranslationKeys } from './en';

export const ja: TranslationKeys = {
  // Common
  common: {
    home: 'ホーム',
    settings: '設定',
    language: '言語',
    loading: '読み込み中...',
    save: '保存',
    cancel: 'キャンセル',
    confirm: '確認',
    close: '閉じる',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: '設定',
    home: 'ホーム',
    howToPlay: '遊び方',
    pieceRules: '駒のルール',
    language: '言語',
    manageSubscription: 'サブスクリプション管理',
    gameHistory: 'ゲーム履歴',
    analytics: '分析',
    premiumAccount: 'プレミアムアカウント',
    chatEnabled: 'チャット: オン',
    chatDisabled: 'チャット: オフ',
  },

  // Piece Rules
  pieceRules: {
    title: '駒のルール',
    description: '駒の動きを学ぶ',
    selectPiece: '駒を選択',
    selectedLabel: '選択中:',
    statusLabel: 'ステータス:',
    statusReady: '準備完了',
    statusViewing: '閲覧中',
    movement: '移動',
    regularMovement: '通常の移動',
    ability: '能力',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: '移動',
    savage: '野生',
    birdtype: '鳥タイプ',
    birdType: '鳥タイプ',
    wallBlock: '壁ブロック',
    moveblocks: '移動ブロック',
    wallclimb: '壁登り',
    lilypad: '睡蓮',
    poisonous: '有毒',
    meadow: '草原',
    parasiticfungi: '寄生菌',
    zombification: 'ゾンビ化',
    fungi: '菌類',
    traverse: '横断',
    capture: '捕獲',
    faint: '気絶',
    leap: '跳躍',
    swing: 'スイング',
    consume: '消費',
    gamble: 'ギャンブル',
    entangle: '絡める',
    ink: 'インク',
    rotate: '回転',
    backstep: '後退',
    trample: '踏みつぶし',
    charge: '突進',
    lane: 'レーン',
    snakestrike: '蛇の攻撃',
    shedskin: '脱皮',
    house: '家',
    plant: '植物タイプ',
    planttype: '植物タイプ',
    capturehost: '宿主捕獲',
    contagion: '感染',
    lonewolf: '孤独な狼',
    hop: 'ホップ',
    decay: '腐敗',
    slide: 'スライド',
    block: 'ブロック',
    poison: '毒',
    infection: '感染',
    howl: '遠吠え',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'クマはチェスのキングのように、あらゆる方向に1マス移動できます',
    bearMovementPost: '味方の駒によってのみブロックされます（ただし木は例外で、クマは木に登れます！）',
    bearSavage: 'クマはサイのブロックのような防御能力を克服できます',
    bearSavagePost: '野生を使うことで、クマはあらゆる方向からあらゆる駒を捕獲でき、致命的な力を加えます',

    // Crane
    craneMovement: 'ツルは直線上を1マスまたは2マス移動できます',
    craneMovementPost: 'ツルは他の駒の上を飛ぶこともできます！',
    craneBirdType: '鳥タイプの駒は大型駒や捕食者の駒を捕獲できません',
    craneBirdTypePost: 'これには木、サイ、クマ、オオカミが含まれます',

    // Frog
    frogMovement: 'カエルは斜めに2マス跳躍します',
    frogMovementPost: '1マスだけ跳ぶことはできません',
    frogWallBlock: 'カエルの通常の2マスの経路が壁または他の駒によってブロックされている場合、捕獲できません',
    frogWallBlockPost: '通常の移動は斜めに1マスに短縮されます',
    frogWallClimb: 'カエルがボードの壁（列AまたはE）にいるとき、上下に1マス移動できます',
    frogWallClimbPost: '味方の駒またはカエルの前にいるサイによってブロックされない限り',
    frogLilypad: 'カエルがゲーム中にまだ移動していない場合、強力な防御能力として最初の3ランクのいずれかに移動できます',
    frogLilypadPost: '睡蓮ジャンプを使用して通常の駒を捕獲できますが、自分より高いランクのサイは例外です',
    frogPoisonous: '動物がカエルの駒を捕獲すると、毒を受けます！',
    frogPoisonousPost: '毒を受けた駒は回復する前に次の利用可能なターンをスキップします',

    // Fungi
    fungiMovement: '菌類はあらゆる方向に1マス移動できます',
    fungiMovementPost: '味方の駒によってのみブロックされます',
    fungiMeadow: '菌類は敵の木の駒の移動能力を減少させます',
    fungiMeadowPost: '敵の木の駒は菌類の駒から1マス以内に移動できません',
    fungiParasitic: '菌類は敵の木の駒を動けなくできます',
    fungiParasiticPost: '菌類が敵の木から1マス以内にいる場合、菌類が離れるか捕獲されるまで移動できません',
    fungiZombification: '菌類は、それを捕獲した敵の動物駒をゾンビ化し、1ターンの間敵の動物を制御できます',
    fungiZombificationPost: 'ゾンビ化された駒は、そのターンの間菌類の駒としても考えられます。菌類がキングであっても、そのターンが終わるまでゲームは終了しません',
    fungiFungi: 'キノコ',
    fungiFungiPost: '毒、絡め、ウイルス感染などですが、ゾンビ化は例外です（他をゾンビ化できるため！）',

    // Goat
    goatMovement: 'ヤギはあらゆる方向に1マス移動できます',
    goatMovementPost: 'ヤギはゆっくり移動しますが、強力な能力を持っています',
    goatTraverse: 'ヤギは接続された他の駒を横断して、大規模な移動の可能性を生み出すことができます',
    goatTraversePost: 'ヤギは気絶したヤギやウイルスなどの小さな駒を横断することはできません',
    goatCapture: 'ヤギは捕食者を捕獲できません',
    goatCapturePost: 'クマやオオカミなど',
    goatFaint: 'ヤギは木やサイなどの大型駒を除いて、捕獲を避けるために気絶できます',
    goatFaintPost: '気絶している間、相手は気絶したヤギの上に「立つ」ことでその移動を止めることができます',

    // Monkey
    monkeyMovement: 'サルはあらゆる方向に1マス移動できます',
    monkeyMovementPost: '利用する他の駒がないと、サルの移動は制限されます',
    monkeyLeap: 'サルはチェッカーゲームのように、直線上の他の駒を飛び越えて、巨大な移動の可能性を得ることができます',
    monkeyLeapPost: 'しかし、敵の駒を飛び越える場合、サルはジャンプを生き延びるためにサイコロを振る必要があり、飛び越える敵ごとに1/6の確率で捕獲されます！',
    monkeySwing: 'サルが木を飛び越えると、サルはボーナスターンを得ます',
    monkeySwingPost: 'ツリースイングを使用すると、サルと木の駒の間に強力な相乗効果が生まれます',
    monkeyConsume: 'サルは菌類の駒を消費してボーナスターンを得ることができます',
    monkeyConsumePost: '他のボーナスターンと組み合わせると、壊滅的なコンビネーションにつながります',
    monkeyGamble: '敵を飛び越えるためにサイコロを振る以外に、サルはクマを捕獲するためにギャンブルしなければなりません',
    monkeyGamblePost: 'サルは6面サイコロで5または6を出してクマを捕獲するか、自分自身が捕獲されます',

    // Octopus
    octopusMovement: 'タコはあらゆる方向に1マス移動します',
    octopusCapture: 'タコは直交方向にのみ捕獲できます',
    octopusCapturePost: 'タコは複雑な方法で駒を捕獲または絡めることができるので、常に赤い捕獲と紫の絡めをチェックしてください！',
    octopusEntangle: 'タコは隣接する敵の駒を絡めて動けなくし、1マス移動して敵を絡めることもできます！',
    octopusEntanglePost: '絡められた駒は、タコが離れるか捕獲されるまで移動できません',
    octopusInk: 'タコはインクを使用して危険な状況から逃れ、最大3つの影を作成できます',
    octopusInkPost: '敵を混乱させ、興味深いおとりや回避プレイを可能にします',

    // Penguin
    penguinMovement: 'ペンギンは設定された方向に直線上をスライドし、壁または駒がその移動をブロックするまで続きます',
    penguinMovementPost: '移動後、ペンギンは同じターン内に最終的な方向を設定することもできます',
    penguinRotate: '試合の開始時、ペンギンは下を向いており、スライドする前に回転する必要があります（眠っているとも呼ばれます）',
    penguinRotatePost: 'ペンギンはどの位置でも、移動する代わりに回転することを選択できます',
    penguinBirdType: 'ペンギンはツルと同様に、捕獲能力が制限されており、木、サイ、クマ、オオカミなどの大型駒や捕食者の駒を捕獲できません',
    penguinBirdTypePost: '捕獲後、ペンギンは戦略的な配置のためにあらゆる方向を向くように回転できます',

    // Rhino
    rhinoMovement: 'サイは前方に2マスのみ移動します',
    rhinoMovementPost: '1マスだけ移動することはできません',
    rhinoBackStep: 'サイは左後方または右後方に移動できます',
    rhinoCharge: 'サイはゲームごとに1回、突進能力を使用して前方に1マス余分に移動できます',
    rhinoChargePost: '壊滅的な移動と捕獲の可能性につながります',
    rhinoTrample: 'サイは踏みつぶしで移動経路上のすべての駒を捕獲します',
    rhinoTramplePost: '気絶したヤギの駒も含みます',
    rhinoLane: 'サイは別の味方の駒と場所を交換でき、戦略的なレーンプレイを可能にします',
    rhinoLanePost: 'ただし、サイと味方の駒の両方がまだ移動していない場合のみ',

    // Snake
    snakeMovement: 'ヘビは直線上を2マス移動できます',
    snakeMovementPost: 'ヘビは壁または味方の駒によってブロックされない限り、正確に2マス移動します',
    snakeMoveBlocks: '壁または捕獲できない駒によってブロックされた場合、ヘビの移動は1マスに短縮されます',
    snakeMoveBlocksPost: '中間の駒がある場合でも、2マス移動できます',
    snakeStrike: 'ヘビは敵の動物がいる場合、前方に3マス攻撃できます',
    snakeStrikePost: '中間の駒がその経路をブロックしない限り',
    snakeShedskin: 'ゲームごとに1回、ヘビは皮を脱いで、マスが空いている場合、最初のランクに戻ることができます',
    snakeShedskinPost: 'この再生は、各ゲームでヘビに追加の命を与えます',

    // Tree
    treeMovement: '木は前方に1マス、またはそのランクの左右の任意のマスに移動できます',
    treeMovementPost: '経路がブロックされていない限り',
    treeHouse: '木は他の駒を収容し、木に登れない敵から保護できます。クマ、ツル、カエル、菌類、ヤギ、サル、タコ、ヘビのように、多くの駒が登ることができます',
    treeHousePost: '木に登ることができる駒が攻撃すると、収容された駒のみを捕獲し、木を保護します',
    treeTrample: '木はサイのように、移動時にマス内のすべての駒を捕獲します',
    treeTramplePost: 'これには気絶したヤギも含まれます',
    treePlant: '木は動物ではなく植物なので、いくつかの効果に対して免疫があります',
    treePlantPost: '毒、ゾンビ化、絡め、ウイルス感染など！',

    // Virus
    virusMovement: 'ウイルスは2マス離れた動物が占めるマスにのみ移動できます',
    virusMoveBlocks: 'ウイルスは壁の隣にある場合、1マスだけ移動できます',
    virusCaptureHost: 'ウイルスが動物の駒の上に（中に）着地すると、それらを感染させるだけで、感染している間も通常のプレイを続けることができます',
    virusCaptureHostPost: 'ウイルスは感染した宿主を離れるときにのみ駒を捕獲します',
    virusContagion: 'ウイルスは1ターンで複数の宿主を感染させることで急速に広がることができます',
    virusContagionPost: '感染により、ウイルスは各ターンに好きなだけ合法的な移動を行うことができます',

    // Wolf
    wolfMovement: 'オオカミはチェスのナイトのようにL字型に移動できます',
    wolfMovementPost: '他の駒によって妨害されません',
    wolfLoneWolf: 'オオカミ',
    wolfLoneWolfPost: 'オオカミは、気絶したヤギまたはウイルスの味方がまだいる場合でも、自分を孤独と見なします',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 ドラッグして探索 • ピンチしてズーム',
    dragToExploreDesktop: '🖱️ ドラッグして探索 • スクロールしてズーム',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: '戻る',
    next: '次へ',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'サンドボックス',
    description: '実験と練習',
    mode: 'モード:',
    modeValue: 'サンドボックス',
    status: 'ステータス:',
    statusReady: '準備完了',
    clearBoard: 'ボードをクリア',
  },

  // Multiplayer
  multiplayer: {
    title: 'マルチプレイヤー',
    description: 'マッチを見つけて競争しよう！',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: '配置マッチ',
    matchProgress: 'マッチ進行状況',
    gamesCompleted: '{games} / 10 ゲーム完了',
    estimatedFinalRating: '推定最終レーティング',
    startingRating: '開始レーティング',
    matchesRemaining: '残り {matches} マッチ',
    findPlacementMatch: '配置マッチを探す',

    // Matchmaking modes
    findMatch: 'マッチを探す',
    competitive: '競争',
    competitiveDesc: 'ランキングが近い対戦相手を見つける',
    quick: 'クイック',
    quickDesc: '素早く競争マッチを見つける',
    casual: 'カジュアル',
    casualDesc: 'ランク外 - 楽しむためにプレイ！',
    placement: 'プレイスメント',
    placementDesc: 'ランクを取得するために10試合を完了',
    startSearch: '検索開始',

    // Searching
    searching: '検索中...',
    mode: 'モード:',
    inQueue: 'キュー内:',
    players: 'プレイヤー',
    playersPlural: 'プレイヤー',
    cancelSearch: '検索をキャンセル',

    // Game info
    status: 'ステータス:',
    ready: '準備完了',
    selectingKing: 'キング選択中',
    placingPieces: '駒を配置中',
    playing: 'プレイ中',
    gameType: 'ゲームタイプ:',
    opponent: '対戦相手:',
    opponentElo: '対戦相手のELO:',
    unranked: 'ランク外',

    // Piece placement
    dragPieces: '駒をボードにドラッグ',
    lightPieces: '明るい駒（あなた）',
    darkPieces: '暗い駒（あなた）',

    // Waiting states
    waitingForOpponent: '対戦相手を待っています...',
    waitingForKing: '対戦相手がキングを選択するのを待っています...',

    // Warnings
    invalidPlacement: '無効な配置',
    lightTurn: '明るいプレイヤーのターンです！',
    darkTurn: '暗いプレイヤーのターンです！',
    onlyLightPieces: '明るい駒のみ配置できます！',
    onlyDarkPieces: '暗い駒のみ配置できます！',
    mustPlaceOnRow: '{color} の駒は行 {row} に配置する必要があります！',

    // Chat
    chat: 'チャット',
    typeMessage: 'メッセージを入力...',
    send: '送信',
  },

  // Main Page
  mainPage: {
    title: 'アニマルチェス',
    subtitle: '人間のためのゲーム',
    playersOnline: '現在オンラインのプレイヤー',
    placement: '配置',
    placementProgress: '配置',
    challengeAI: 'AIに挑戦',
    multiplayer: 'マルチプレイヤー',
    sandbox: 'サンドボックス',
    tutorials: 'チュートリアル',
    shop: 'ショップ',
    collection: 'コレクション',
    history: '履歴',
    analytics: '分析',
    courses: 'コース',
    upgradeAccount: 'アカウントをアップグレード',
    signIn: 'サインイン',
    playAsGuest: 'ゲストとしてプレイ',
    welcomeBack: 'おかえりなさい！あなたは通常次のようにプレイします',

    // Learn the Pieces section
    learnThePieces: '駒を学ぶ',

    // Learn the Rules section
    learnTheRules: 'ルールを学ぶ',
    premiseTitle: '前提',
    premiseText: 'ゾディアックは13種類の駒から選ばれた隠されたキングを持つチェスの代替品です。独自のロスターを選択し、相手をブラフして5×8のボード上で倒しましょう',
    selectionTitle: '選択',
    selectionText: 'ゲームを開始するには、秘密裏にキングを選択し、相手と交互に5つの駒を配置して、5000億以上の初期状態の1つを作成します。',
    objectiveTitle: '目的',
    objectiveText: '相手を読んで秘密のキングを捕獲するか、キングをボード全体にレースして勝利を確保してください！',
    competeTitle: '競争',
    competeText: 'ラダーでスキルをテストし、新しい個人的なテクニックと戦略を開発し、ランクアップして最高のプレイヤーに挑戦しましょう！',
    fullRulesButton: '完全な公式ルールについてはここをクリック',

    // FAQ section
    faqTitle: 'よくある質問',
    faqQuestion1: 'ゾディアックチェスの背後にあるアイデアは何ですか？',
    faqAnswer1: 'ゾディアックチェスは、ボビー・フィッシャーがチェス960を作るきっかけとなった言葉に触発されました。私たちは、暗記との戦いと、測り知れない深さでの人間の直感を祝福するというアイデアを拡大したかったのです！',
    faqQuestion2: 'なぜチェスの代替品が必要なのですか',
    faqAnswer2: '必要ありません！ゾディアックは人々をチェスから遠ざけたくありません！それは独自の長所と短所を持つ別のオプションです。楽しんでいただき、新しいプレイを活気づけるためにこのゲームを適応させるのを手伝ってください',
    faqQuestion3: 'ゾディアックチェスでどのように勝ちますか？',
    faqAnswer3: '勝つ方法は3つあります：相手の隠されたキングの駒を捕獲する、自分のキングをボードの反対側にレースする、またはタイムコントロールのある試合で相手の時間を使い果たすことです',
    faqQuestion4: 'これはFAQですか？',
    faqAnswer4: 'はい、FAQにリストされている質問のいずれかを見ることができます。詳細が必要な場合は、質問をクリックして、今読んでいるこれらの詳細のように、次の詳細を読むことができます',
    faqQuestion5: '典型的なゲームはどのくらいの時間がかかりますか？',
    faqAnswer5: '各ゲームは大きく異なります！一部のゲームは2手で終わり、一部は30分かかる場合があります。通常、5〜15分のマークにある傾向があります！',
    faqQuestion6: '誰も合法的な移動ができない場合、何が起こりますか？',
    faqAnswer6: 'プレイヤーが合法的な移動を行えない場合（ステイルメイト）、ゲームは引き分けで終了します。ゲームは、繰り返し（同じボード状態が3回）またはプレイヤー間の相互合意によっても引き分けで終了する可能性があります！',

    // About section
    aboutButton: '概要',
    privacyPolicy: 'プライバシーポリシー',
    developerInterface: '開発者インターフェース',
  },

  // About Modal
  about: {
    title: 'ゾディアックについて',
    paragraph1: 'ゾディアックは、LoLやDotAのようなゲームからの駒の選択要素と、ポーカーや社会的推論ゲームからのブラフメカニクスを組み合わせたチェスのようなボードゲームです。',
    paragraph2: 'ゲームの初期バージョンは2014年にシャドウチェスという名前で作成されました。2018年には、バランスが取れているがユニークな移動パターンと能力を持つ楽しい駒のロスターを含む、今日見られるものに再設計されました。',
    paragraph3: '私たちのビジョンは、すべてのユーザーのゲームプレイデータを記録して、ゲームプレイを新鮮に保ち、新しいプレイを奨励するためにゲームを進化させ続けることです。',
    paragraph4: 'ゾディアックの巨大な検索スペース、隠された情報、オープニングボードの位置により、AIの支配を食い止め、ゾディアックを人間のためのゲームに保つことを望んでいます！',
  },

  // Privacy Policy
  privacy: {
    title: 'プライバシーポリシー',
    lastUpdated: '最終更新',

    introduction: {
      title: 'はじめに',
      p1: 'ゾディアックチェス（「当社」、「私たち」、または「私たち」）へようこそ。私たちはあなたのプライバシーを保護し、安全で楽しいゲーム体験を提供することに取り組んでいます。このプライバシーポリシーは、ウェブサイトとゲームを使用する際に、私たちがどのように情報を収集、使用、開示、および保護するかを説明します。',
      p2: 'ゾディアックチェスを使用することにより、このポリシーに従って情報の収集と使用に同意したことになります。私たちのポリシーと慣行に同意しない場合は、サービスを使用しないでください。',
      contact: 'お問い合わせ:',
    },

    infoCollect: {
      title: '収集する情報',
      accountInfo: {
        title: '1. アカウント情報',
        item1: 'メールアドレス：アカウント作成とコミュニケーションに必要',
        item2: 'ユーザー名：選択した表示名',
        item3: 'パスワード：暗号化され安全に保存',
      },
      gameData: {
        title: '2. ゲームデータ',
        item1: 'ゲーム統計：勝敗、ELOレーティング、配置マッチの進行状況',
        item2: 'ゲームプレイデータ：駒の選択、行われた移動、使用された戦略',
        item3: 'マッチ履歴：プレイされたゲームの記録、対戦した相手',
        item4: 'ゲーム内購入：コスメティックアイテムとプレミアムメンバーシップステータス',
      },
      technicalData: {
        title: '3. 技術データ',
        item1: 'デバイス情報：ブラウザの種類、オペレーティングシステム',
        item2: '使用データ：訪問したページ、費やした時間、使用した機能',
        item3: 'ローカルストレージ：言語設定、UI設定、一時的なゲーム状態',
      },
    },

    children: {
      title: '子供のプライバシー（COPPA準拠）',
      p1: 'ゾディアックチェスは、子供を含むすべての年齢のプレイヤーに適したファミリーフレンドリーなデザインになっています。私たちは子供のオンラインプライバシー保護法（COPPA）に準拠するよう特別な注意を払っています。',
      p2: '13歳未満のユーザーの場合：アカウント作成またはデータ収集を必要としないゲストプレイモードを使用することをお勧めします。ゲストアカウントはテキストチャット機能にアクセスできず、子供がインターネット上のコミュニケーションにさらされないようにします。子供がアカウントを作成する場合、個人情報を収集する前に親の同意が必要です。',
      p3: '私たちは、検証された親の同意なしに13歳未満の子供から個人情報を故意に収集、使用、または共有することはありません。',
      p4: 'チャットの安全性：テキストチャットは、すべてのゲスト/一時アカウントで自動的に無効になります。標準アカウント所有者は、いつでもアカウント設定でチャット機能を無効にするオプションがあります。',
      parentalRights: '親は次の権利を持っています:',
      right1: '子供の個人情報を確認する',
      right2: '子供のデータの削除を要求する',
      right3: '子供の情報のさらなる収集または使用を拒否する',
      contactUs: 'これらの権利を行使するため、または子供が個人情報を提供したと思われる場合は、contact@zodiac-chess.comまですぐにご連絡ください',
    },

    howWeUse: {
      title: '情報の使用方法',
      item1: 'ゲームサービスを提供および改善する',
      item2: 'スキルレベルに基づいて適切な対戦相手とマッチングする',
      item3: '進行状況、統計、成果を追跡する',
      item4: 'プレミアムメンバーシップとコスメティックアイテムの支払いを処理する',
      item5: '重要なサービスのお知らせと更新を送信する',
      item6: 'ゲームプレイデータを分析してゲームのバランスと機能を改善する',
    },

    thirdParty: {
      title: 'サードパーティサービス',
      firebase: {
        title: 'Firebase（Google）',
        description: '認証、データベースストレージ、マルチプレイヤー機能にFirebaseを使用しています。Firebaseは、プライバシーポリシーに記載されている特定のデータを収集する場合があります。',
      },
      stripe: {
        title: 'Stripe',
        description: 'プレミアムメンバーシップとアプリ内購入の支払いを処理するためにStripeを使用しています。Stripeはすべての支払いカード情報を処理します - 私たちは完全な支払い詳細を見ることも保存することもありません。',
      },
      netlify: {
        title: 'Netlify',
        description: 'ウェブサイトはNetlifyでホストされており、IPアドレスやアクセスログなどの標準的なウェブホスティングデータを収集する場合があります。',
      },
      adsense: {
        title: 'Google AdSense（将来）',
        description: 'Google AdSenseを通じて広告を表示する場合があります。これらの広告は、パーソナライゼーションのためにクッキーを使用する場合があります。子供向けコンテンツの場合、COPPAに準拠して非パーソナライズド広告のみを表示します。',
      },
      viewPolicy: 'プライバシーポリシーを表示',
    },

    cookies: {
      title: 'クッキーとローカルストレージ',
      description: 'エクスペリエンスを向上させるために、ブラウザのローカルストレージ（クッキーに類似）を使用します:',
      item1: '言語設定：選択した言語を記憶',
      item2: 'アカウントセッション：ログイン状態を維持（Firebaseと連携）',
      item3: 'ゲーム設定：UI設定とサンドボックス設定を記憶',
      item4: '広告クッキー：同意した場合、サードパーティの広告サービスは広告のパーソナライゼーションのためにクッキーを使用する場合があります',
    },

    security: {
      title: 'データセキュリティ',
      p1: '情報を保護するために適切なセキュリティ対策を実施しています:',
      item1: 'パスワードの暗号化：すべてのパスワードは業界標準の方法を使用して暗号化',
      item2: '安全な接続：すべてのデータ送信にHTTPS暗号化',
      item3: 'Firebaseセキュリティルール：厳格なデータベースアクセス制御',
      p2: 'ただし、インターネット上の送信方法は100％安全ではありません。データを保護するよう努めていますが、絶対的なセキュリティを保証することはできません。',
    },

    retention: {
      title: 'データ保持',
      p1: 'データを次のように保持します:',
      item1: 'アクティブなアカウント：アカウントがアクティブな間、データを保持',
      item2: '非アクティブなアカウント：アカウントが10年間非アクティブな場合、データを削除する場合があります',
    },

    rights: {
      title: 'プライバシー権',
      description: 'お住まいの地域によっては、次の権利がある場合があります:',
      access: {
        title: 'アクセス:',
        description: '個人データのコピーを要求',
      },
      correction: {
        title: '訂正:',
        description: 'データの訂正を要求',
      },
      deletion: {
        title: '削除:',
        description: 'アカウントとデータの削除を要求',
      },
      portability: {
        title: 'データポータビリティ:',
        description: 'ポータブル形式でデータを要求',
      },
      optOut: {
        title: 'オプトアウト:',
        description: 'マーケティングコミュニケーションをオプトアウト',
      },
      contact: 'これらの権利のいずれかを行使するには、contact@zodiac-chess.comまでお問い合わせください',
    },

    international: {
      title: '国際ユーザー',
      p1: 'ゾディアックチェスはニュージーランドから運営されています。ニュージーランド以外からサービスにアクセスしている場合、情報がニュージーランドおよびサービスプロバイダーが運営する他の国に転送、保存、処理される可能性があることに注意してください。',
      p2: 'サービスを使用することにより、居住国外の国への情報の転送に同意したことになります。これらの国には、異なるデータ保護法がある場合があります。',
    },

    changes: {
      title: 'このプライバシーポリシーの変更',
      description: 'このプライバシーポリシーを随時更新する場合があります。このページに新しいプライバシーポリシーを掲載し、「最終更新」日付を更新することで、変更を通知します。重要な変更は、電子メールまたはウェブサイト上の目立つ通知を通じて伝達されます。',
    },

    contact: {
      title: 'お問い合わせ',
      description: 'このプライバシーポリシーまたはデータ慣行に関して質問、懸念、またはリクエストがある場合は、お問い合わせください:',
      email: 'メール:',
      company: '会社:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: '利用規約',
    lastUpdated: '最終更新日',
    back: '戻る',
    viewPrivacyPolicy: 'プライバシーポリシーを見る',
    acknowledgment: 'Zodiac Chessを使用することにより、この利用規約を読み、理解し、拘束されることに同意したことを認めます。',
    acceptance: {
      title: '1. 規約の承諾',
      p1: 'Zodiac Chess（「サービス」）にアクセスし使用することにより、この利用規約に拘束されることを承諾し同意します。これらの規約に同意しない場合は、サービスを使用しないでください。',
      p2: '当社はいつでもこれらの規約を変更する権利を留保します。変更後のサービスの継続使用は、変更された規約の承諾を構成します。',
    },
    description: {
      title: '2. サービスの説明',
      p1: 'Zodiac Chessは、特殊能力を持つユニークな動物の駒を特徴とするオンライン戦略ボードゲームです。サービスには以下が含まれます：',
      feature1: 'AI対戦のシングルプレイヤーゲームプレイ',
      feature2: 'マルチプレイヤーマッチメイキングと競技プレイ',
      feature3: 'インタラクティブなチュートリアルと学習リソース',
      feature4: 'アカウント作成と進捗追跡',
      feature5: 'オプションのプレミアムサブスクリプション機能',
      feature6: 'コスメティックカスタマイズオプション',
    },
    accounts: {
      title: '3. ユーザーアカウント',
      eligibility: {
        title: '3.1 資格',
        p1: 'アカウントを作成するには13歳以上である必要があります。13歳未満のユーザーは保護者の監督の下でゲストプレイモードを使用できますが、アカウントを作成することはできません。',
      },
      responsibilities: {
        title: '3.2 アカウントセキュリティ',
        p1: 'あなたは以下の責任を負います：',
        item1: 'パスワードの機密性を維持すること',
        item2: 'アカウントで発生するすべての活動',
        item3: '不正使用があった場合は直ちに当社に通知すること',
        p2: '当社は不正なアカウントアクセスから生じるいかなる損失や損害についても責任を負いません。',
      },
      prohibited: {
        title: '3.3 禁止事項',
        p1: '以下の行為は禁止されています：',
        item1: 'アカウントを他者と共有すること',
        item2: '複数のアカウントを使用してランキングを操作すること',
        item3: 'ボット、スクリプト、または自動化ツールを使用してゲームをプレイすること',
        item4: '他のプレイヤーを嫌がらせ、虐待、または脅迫すること',
        item5: 'バグやグリッチを悪用して不正な利益を得ること',
        item6: 'リバースエンジニアリングまたはソースコードへのアクセスを試みること',
        p2: 'これらのルールの違反はアカウントの停止または永久禁止につながる可能性があります。',
      },
    },
    premium: {
      title: '4. プレミアムサブスクリプション',
      billing: {
        title: '4.1 請求',
        p1: 'プレミアムサブスクリプションはStripeを通じて処理されます。プレミアムサブスクリプションを購入することにより、キャンセルするまで定期的に支払い方法に請求することを当社に許可します。',
        p2: 'サブスクリプション料金は：',
        item1: '月額プラン：購入日の毎月同日に請求',
        item2: '年額プラン：購入日の毎年同日に請求',
        p3: '価格は、アクティブな購読者への30日前の通知により変更される場合があります。',
      },
      cancellation: {
        title: '4.2 キャンセル',
        p1: 'アカウント設定またはサポートへの連絡を通じて、いつでもサブスクリプションをキャンセルできます。キャンセルは現在の請求期間の終了時に有効になります。',
        p2: 'キャンセル後も、支払い済み期間の終了までプレミアム機能を保持できます。',
      },
      refunds: {
        title: '4.3 返金',
        p1: '月額サブスクリプション：月の途中の返金はありません。将来の請求を停止するにはいつでもキャンセルしてください。',
        p2: '年額サブスクリプション：購入から7日以内に要求された場合は全額返金。7日後の返金は当社の裁量によります。',
        p3: 'コスメティック購入：一般的に返金不可。例外的な状況についてはサポートにお問い合わせください。',
      },
    },
    acceptable: {
      title: '5. 許容使用ポリシー',
      p1: 'Zodiac Chessを敬意を持って合法的な方法で使用することに同意します。禁止される行為には以下が含まれます：',
      item1: '不正行為、ハッキング、またはゲームメカニクスの悪用',
      item2: '嫌がらせ、ヘイトスピーチ、または差別的な言葉',
      item3: 'スパム、広告、または勧誘',
      item4: '不適切なコンテンツの共有（チャットまたはユーザー生成コンテンツが有効な場合）',
      item5: '他のユーザーまたはスタッフメンバーになりすますこと',
      item6: 'サービスを妨害または損傷しようとすること',
      p2: '当社は違反を調査し、必要に応じてアカウントの終了や当局への報告を含む適切な措置を講じる権利を留保します。',
    },
    intellectual: {
      title: '6. 知的財産権',
      ownership: {
        title: '6.1 当社のコンテンツ',
        p1: 'ゲームメカニクス、アートワーク、アニメーション、サウンドエフェクト、コード、デザインを含むがこれらに限定されないすべてのゲームコンテンツは、Animal Chess Limitedまたは当社のライセンサーが所有しています。',
        p2: '個人的な娯楽目的でのみサービスを使用するための限定的、非独占的、譲渡不可のライセンスが付与されます。',
      },
      userContent: {
        title: '6.2 ユーザーコンテンツ',
        p1: 'コンテンツ（チャットメッセージ、ユーザー名、またはプロフィール情報など）を提出することにより、サービスに関連してそのコンテンツを使用、表示、および配布するための世界規模の、ロイヤリティフリーのライセンスを当社に付与します。',
        p2: '提出するコンテンツの所有権または必要な権利を有していることを表明します。',
      },
    },
    disclaimers: {
      title: '7. 免責事項と責任の制限',
      p1: 'サービスは、明示または黙示を問わず、いかなる種類の保証もなく「現状のまま」提供されます。',
      p2: '当社は以下を保証しません：',
      item1: 'サービスが中断なく、またはエラーなしで動作すること',
      item2: '欠陥が修正されること',
      item3: 'サービスがウイルスや有害なコンポーネントを含まないこと',
      item4: 'サービスの使用結果がお客様の期待に応えること',
      p3: '法律で許容される最大限の範囲で、当社は以下について責任を負いません：',
      item5: '間接的、偶発的、または結果的な損害',
      item6: '利益、データ、または信用の損失',
      item7: 'サービスの中断またはデータの損失',
      item8: '過去12か月間にお客様が当社に支払った金額を超える損害',
    },
    privacy: {
      title: '8. プライバシー',
      p1: 'サービスの使用は、個人情報の収集、使用、および保護方法を説明するプライバシーポリシーによっても規制されます。',
      p2: 'サービスを使用することにより、プライバシーポリシーに記載されている当社のデータ慣行に同意します。',
    },
    changes: {
      title: '9. 規約の変更',
      p1: '当社はいつでもこの利用規約を変更する権利を留保します。重要な変更については、以下の方法でユーザーに通知します：',
      item1: '登録ユーザーへのメール通知',
      item2: 'ウェブサイト上の目立つ通知',
      item3: 'このページ上部の「最終更新日」の更新',
      p2: '変更後のサービスの継続使用は、変更された規約の承諾を構成します。',
    },
    governing: {
      title: '10. 準拠法',
      p1: 'この利用規約は、法の抵触に関する原則に関係なく、ニュージーランドの法律に準拠します。',
      p2: 'これらの規約またはサービスの使用から生じる紛争は、ニュージーランドの裁判所で解決されます。',
    },
    contact: {
      title: '11. 連絡先情報',
      p1: 'この利用規約に関する質問、懸念、またはサポートについて：',
      email: 'メール：',
      company: '会社：',
      address: '住所：',
    },
    severability: {
      title: '12. 分離可能性',
      p1: 'これらの規約のいずれかの条項が執行不能または無効と判断された場合、その条項は必要最小限の範囲で制限または削除され、残りの条項は完全な効力を維持します。',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'クッキーポリシー',
    lastUpdated: '最終更新日',
    browserInstructions: {
      chrome: '設定 → プライバシーとセキュリティ → Cookie',
      firefox: '設定 → プライバシーとセキュリティ → Cookieとサイトデータ',
      safari: '環境設定 → プライバシー → Cookieとウェブサイトのデータ',
      edge: '設定 → プライバシー、検索、サービス → Cookie',
    },
    cookieTable: {
      name: 'Cookie名',
      purpose: '目的',
      duration: '期間',
      type: '種類',
    },
    relatedPolicies: {
      title: '関連ポリシー',
      description: '当社のデータ取り扱いについて詳しくは、以下をご覧ください：',
      privacy: 'プライバシーポリシー',
      terms: '利用規約',
    },

    introduction: {
      title: 'はじめに',
      p1: 'このクッキーポリシーは、Zodiac Chess（「当社」または「私たち」）が、お客様が当社のウェブサイトを訪問する際にCookieおよび類似技術をどのように使用するかについて説明します。',
      p2: '当社のウェブサイトを使用することにより、このポリシーに従った当社のCookie使用に同意したものとみなされます。同意されない場合は、ブラウザの設定でCookieを無効にするか、当社のウェブサイトを使用しないでください。',
    },
    what: {
      title: 'Cookieとは？',
      p1: 'Cookieは、ウェブサイトを訪問する際にお客様のデバイス（コンピュータ、スマートフォン、タブレット）に保存される小さなテキストファイルです。ウェブサイトを効率的に動作させ、ウェブサイト所有者に情報を提供するために広く使用されています。',
      p2: 'Cookieは、お客様の設定を記憶したり、サイトの利用状況を分析したり、特定の機能を有効にしたりするなど、さまざまな目的で使用されます。',
    },
    types: {
      title: '使用するCookieの種類',
      necessary: {
        title: '1. 必須Cookie',
        description: 'これらのCookieは、ウェブサイトが正常に機能するために不可欠です。これらのCookieがなければ、お客様が要求したサービスを提供することはできません。',
        examples: '例：',
        item1: '認証Cookie - アカウントへのログイン状態を維持',
        item2: 'セキュリティCookie - 不正行為から保護',
        item3: 'セッションCookie - セッション中のゲーム状態を維持',
        item4: 'Cookie同意設定 - お客様のCookie選択を記憶',
      },
      analytics: {
        title: '2. 分析Cookie',
        description: 'これらのCookieは、ページ訪問、滞在時間、使用された機能に関する匿名情報を収集することで、訪問者が当社のウェブサイトとどのようにやり取りするかを理解するのに役立ちます。',
        provider: 'プロバイダー: Firebase Analytics (Google)',
        purpose: '目的：',
        item1: 'ウェブサイトのトラフィックとユーザーエンゲージメントを測定',
        item2: '人気のある機能とページを特定',
        item3: 'ユーザーの属性を理解（年齢層、おおよその位置）',
        item4: 'ウェブサイトのパフォーマンスとユーザーエクスペリエンスを向上',
      },
      advertising: {
        title: '3. 広告Cookie',
        description: 'これらのCookieは、お客様に関連性の高い広告を表示するために使用されます。また、広告の表示回数を制限し、広告キャンペーンの効果を測定するのに役立ちます。',
        provider: 'プロバイダー: Google AdSense',
        purpose: '目的：',
        item1: 'お客様の興味に基づいたパーソナライズド広告を表示',
        item2: '広告のパフォーマンスとエンゲージメントを測定',
        item3: '同じ広告を何度も表示することを防止',
        note: '注：プレミアム会員は、Cookie設定に関係なく、広告が表示されることはありません。',
      },
    },
    firstThird: {
      title: 'ファーストパーティCookieとサードパーティCookie',
      firstParty: {
        title: 'ファーストパーティCookie',
        description: 'これらはZodiac Chessによって直接設定されるCookieです。サイトの基本機能、認証、および設定の記憶に使用されます。',
      },
      thirdParty: {
        title: 'サードパーティCookie',
        description: 'これらは、Google AnalyticsやGoogle AdSenseなど、当社が使用する外部サービスによって設定されるCookieです。サードパーティCookieは、それらのプロバイダーのプライバシーポリシーの対象となります。',
      },
    },
    specific: {
      title: '使用している特定のCookie',
      tableHeader: '以下は、当社のウェブサイトで使用されているCookieの詳細なリストです：',
    },
    control: {
      title: 'Cookieの制御方法',
      consent: {
        title: '1. Cookie同意バナー',
        description: '当社のウェブサイトに初めてアクセスすると、Cookie同意バナーが表示されます。以下のことができます：',
        item1: 'すべて受け入れ - すべてのCookieを許可（必須、分析、広告）',
        item2: 'オプションを拒否 - 必須Cookieのみを許可（分析や広告なし）',
        item3: 'カスタマイズ - 許可するCookieの種類を正確に選択',
      },
      browser: {
        title: '2. ブラウザ設定',
        description: 'ほとんどのウェブブラウザでは、設定を通じてCookieを制御できます。以下のことができます：',
        item1: 'すべてのCookieをブロック',
        item2: 'ファーストパーティCookieのみを受け入れ',
        item3: 'ブラウジングセッションごとにCookieを削除',
        item4: '個々のCookieを表示して削除',
        links: '主要なブラウザのCookie管理へのリンク：',
      },
      optOut: {
        title: '3. オプトアウトツール',
        description: '広告Cookieについては、パーソナライズド広告をオプトアウトできます：',
        googleLink: 'Google広告設定',
        googleDesc: ' - Googleパーソナライズド広告を管理',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - インタレストベース広告をオプトアウト',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - EU特有のオプトアウトツール',
      },
    },
    impact: {
      title: 'Cookieを無効にした場合の影響',
      p1: 'Cookieを無効にしたり拒否したりする場合、以下の点にご注意ください：',
      item1: 'ウェブサイトの一部が正常に機能しない場合があります',
      item2: '訪問するたびに設定を再入力する必要がある場合があります',
      item3: 'アカウントからログアウトされる場合があります',
      item4: '必須Cookieはサイトの動作に必要です - 無効にするとコア機能を使用できなくなります',
    },
    updates: {
      title: 'このクッキーポリシーの更新',
      p1: '当社は、慣行の変更を反映するため、または法的、規制上、または運用上の理由により、このクッキーポリシーを随時更新する場合があります。',
      p2: '重要な変更については、このページ上部の「最終更新日」を更新することでお知らせします。このポリシーを定期的にご確認ください。',
    },
    contact: {
      title: 'お問い合わせ',
      p1: '当社のCookie使用またはこのクッキーポリシーについてご質問がある場合は、以下までお問い合わせください：',
      email: 'メール：',
      company: '会社：',
    },
  },

  // Game
  game: {
    yourTurn: 'あなたの番',
    opponentTurn: '相手の番',
    victory: '勝利！',
    defeat: '敗北',
    draw: '引き分け',
    resign: '投了',
    offerDraw: '引き分けを提案',
  },

  // Game Info
  gameInfo: {
    title: 'ゲーム情報',
    sandboxMode: 'サンドボックスモード',
    lightTurn: 'ライトの番',
    darkTurn: 'ダークの番',
    yourTurn: 'あなたの番',
    opponentTurn: '相手の番',
    aiThinking: 'AI思考中...',

    // Selection states
    selecting: '{piece}を選択中',
    observing: '{piece}を観察中',
    selectingZombified: 'ゾンビ化した敵の{piece}を選択中',
    selectionLocked: '{piece}に選択がロックされています',
    selectionLockedPenguin: 'ペンギンは選択がロックされています',

    // Hints
    clickToFaint: '{piece}をクリックして気絶させる',
    clickToRotate: '{piece}をクリックして回転させる',
    clickToInk: '{piece}をクリックしてインクを噴射',
    zombifiedWarning: '⚠️ ゾンビ化中、{piece}は移動前に回転します！',

    // Monkey bonus turn
    monkeySwing: 'サルがスイングを完了しました。ボーナスターンを完了するためにサルを移動してください',
    monkeyConsume: 'サルがキノコを食べました。ボーナスターンを完了するためにサルを移動してください',

    // Virus bonus turn
    virusInfecting: 'ウイルスが感染中です。ターンを続けるか、ウイルスをクリックしてターンを終了してください',

    // Penguin bonus turn
    penguinRotate: 'ペンギンがスライドを完了しました - 最終回転方向を選択してください',
    penguinCaptureRotate: 'ペンギンが捕獲を完了しました - 最終回転方向を選択してください',
    penguinZombified: 'ゾンビ化したペンギンが回転しました - スライド/捕獲でターンを完了（ゾンビ化は終了します）',

    // Capture restrictions
    cannotCapture: '{piece}は捕獲できません：{targets}',
    cannotInfect: '{piece}は感染させられません：{targets}',
    cannotEntangle: '{piece}は絡めとれません：{targets}',
    monkeyBearRoll: '{piece}は敵の{target}を捕獲するには5-6を出す必要があります',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'クマ',
    Crane: 'ツル',
    Frog: 'カエル',
    Fungi: 'キノコ',
    Goat: 'ヤギ',
    Monkey: 'サル',
    Octopus: 'タコ',
    Penguin: 'ペンギン',
    Rhino: 'サイ',
    Snake: 'ヘビ',
    Tree: '木',
    Virus: 'ウイルス',
    Wolf: 'オオカミ',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: '移動コンテキスト',
    emptyState: '詳細情報を表示するには、左パネルから能力を選択してください。',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AIアリーナ',
    tagline: '対戦するAIを選ぶか、AI同士の対決を観戦しよう！',

    // Player labels
    lightPlayer: 'ライトプレイヤー',
    darkPlayer: 'ダークプレイヤー',
    humanPlayer: '人間プレイヤー',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'センチネル',
    aiAlchemist: 'アルケミスト',
    aiZenith: 'ゼニス',
    aiTrapper: 'トラッパー',
    aiHunter: 'ハンター',
    aiWisp: 'ウィスプ',
    aiCreature: 'Creature',
    aiWeaver: 'ウィーバー',

    // Time Frames
    timeFast: '高速',
    timeStandard: '標準',
    timeDeep: '深思考',

    // Thinking time
    thinkingTime: '思考時間',

    // Info box
    matchupLabel: '対戦：',
    statusLabel: 'ステータス：',
    statusPaused: '一時停止',
    statusAIThinking: 'AI思考中...',
    statusInGame: 'ゲーム中',
    statusReady: '準備完了',
    matchupLocal2P: 'ローカル2P',
    matchupPlayerVs: 'プレイヤー vs',
    matchupVsPlayer: 'vs プレイヤー',

    // Buttons
    startButton: 'スタート',
    startRandomButton: 'ランダム開始',
    newGameButton: '新しいゲーム',
    resumeButton: '再開',
    pauseButton: '一時停止',
    pauseQueuedButton: '一時停止（待機中...）',
    viewKingsButton: 'キングを表示',
    hideKingsButton: 'キングを非表示',
    viewKingsQueuedButton: 'キングを表示（待機中...）',
    hideKingsQueuedButton: 'キングを非表示（待機中...）',
    homeButton: 'ホーム',
    toggleKingVisibility: 'キングの表示/非表示を切り替え',

    // Warning modal
    invalidPlacement: '無効な配置',
    okButton: 'OK',
    warningLightTurn: 'ライトプレイヤーが駒を配置する番です！',
    warningDarkTurn: 'ダークプレイヤーが駒を配置する番です！',
    warningLightRow: 'ライトの駒は列0（あなたのホーム列）に配置する必要があります！',
    warningDarkRow: 'ダークの駒は列7（あなたのホーム列）に配置する必要があります！',
    warningOccupied: 'このマスはすでに占有されています！空のマスを選んでください。',
    warningKingRequired: '5番目の駒を配置する前にキング（{kingType}）を配置する必要があります！',

    // Piece selection
    dragPieces: '駒をボードにドラッグ',
    lightPieces: 'ライトの駒',
    darkPieces: 'ダークの駒',

    // Mobile
    selectYourKing: 'キングを選択',
    selectPieceToPlace: '配置する駒を選択',
    moveHistory: '移動履歴',
    historyButton: '履歴',
    backButton: '戻る',
    lightTurn: 'ライトの番',
    darkTurn: 'ダークの番',
  },

  // Donation
  donation: {
    title: 'Zodiac Chessを支援する',
    supportDevelopment: '開発を支援する',
    story1: 'こんにちは！あなたの支援がこのユニークなゲームの改善を続けることを助けています！新機能の追加、サーバーの維持、そしてZodiac Chessをコミュニティのために無料で提供し続けています。',
    story2: '小さな寄付でも大きな違いを生み、このプロジェクトを生かし続けます。Zodiac Chessの旅の一員になっていただきありがとうございます :)',
    selectAmount: '金額を選択',
    customAmount: 'またはカスタム金額を入力：',
    total: '合計：',
    donateButton: '今すぐ寄付',
    processing: '処理中...',
    disclaimer: '寄付は開発とサーバー費用をサポートします。ご厚意に感謝します！',
    invalidAmount: '0円より大きい有効な金額を入力してください',
    error: '寄付の処理中にエラーが発生しました。もう一度お試しください。',
  },

  // Game End Popup
  gameEnd: {
    victory: '勝利！',
    defeat: '敗北！',
    draw: '引き分け！',
    wonBy: '{condition}による勝利',
    lostBy: '{condition}による敗北',
    drawBy: '{condition}による引き分け',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'キング討伐',
      race: 'レース勝利',
      timeout: 'タイムアウト',
      threefold: '3回繰り返し',
      noMoves: '有効な手なし',
      draw: '引き分け',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'プレミアムにアップグレード',
    accountRequired: 'プレミアムにアップグレードする前に、永続的なアカウントを作成する必要があります。',
    createAccountPrompt: 'アカウントを作成して進捗を保存し、プレミアム機能をアンロックしましょう！',
    subtitle: 'Zodiac Chess体験を強化する強力な機能をアンロックしよう！',
    features: {
      history: 'アカウント履歴',
      historyItem1: '過去のすべてのゲームを保存して呼び出す',
      historyItem2: '戦略を評価するために任意のポイントから古いゲームをリプレイ',
      historyItem3: '深層分析を使用してボードポジションと素晴らしい手の機会を分析',
      analytics: '分析',
      analyticsItem1: 'ゲーム統計にアクセス',
      analyticsItem2: '多数の指標にわたってユーザーの駒とキングの選択を分析',
      analyticsItem3: 'どのメタが人気で何が機能しているかを発見！',
      course: 'コース',
      courseItem1: 'スキルを向上させる最新のコースにアクセス',
      courseItem2: 'プロからメタとコンセプトを学ぶ',
      courseItem3: '自分の弱点を分析するためのゲームプレイのヒントを得る',
    },
    createAccount: 'アカウント作成',
    upgradeNow: '今すぐアップグレード',
    cancel: 'キャンセル',
  },

  // Premium Modal
  premium: {
    title: 'プレミアム機能',
    accessDenied: '申し訳ありませんが、プレミアムアカウントをお持ちでないため、これらの機能にはまだアクセスできません！',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'エラーが発生しました',
    errorMessage: 'お支払いの処理中に問題が発生しました。ご安心ください、請求はされていません。',
    whatHappened: '何が起こりましたか？',
    notCompleted: 'お支払いが完了しませんでした。原因として考えられるのは：',
    reasons: {
      cancelled: '支払いがキャンセルされました',
      declined: 'カードが拒否されました',
      connection: 'チェックアウト中に接続の問題が発生しました',
      expired: 'セッションが期限切れになりました',
    },
    whatToDo: 'どうすればいいですか？',
    actions: {
      tryDifferentCard: '別のカードで再試行する',
      tryDifferentCardDesc: '別の支払い方法を使用してください',
      retryPayment: '支払いを再試行する',
      retryPaymentDesc: '単純な再試行で解決することもあります',
      checkBank: '銀行に確認する',
      checkBankDesc: 'カードに十分な残高があることを確認してください',
    },
    tryAgain: '再度アップグレードを試す',
    returnHome: 'メインページに戻る',
    contactSupport: 'ヘルプが必要ですか？support@zodiac-chess.comまでお問い合わせください',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
